<div class="messageArea">
  <p i18n="@@shared.pageNotFound.txtPageNotFound">Page not found</p>
  <a routerLink="/" i18n="@@shared.pageNotFound.txtBackToHome">Back To Home</a>
</div>
